<div class="order-assigned-template-content">
  <div class="conditions">
    <ng-container #selectOrList *ngFor="let allConditionsSelectValue of currentAllConditionsSelectValue; let j = index">
      <div class="outline-and-conditions">
        <ng-container
          #selectList
          *ngFor="let conditionSelectValue of currentAllConditionsSelectValue[j]; let i = index">
          <div class="condition">
            <div class="header-text" *ngIf="i == 0; else othwerWise"><b>IF</b></div>
            <ng-template #othwerWise>
              <div class="header-text">AND <b>IF</b></div>
            </ng-template>
            <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
            <div class="select-wrapper">
              <mat-select
                #conditionSelect
                class="pdq-mat-select pdq-mat-select--ghost-underline"
                panelClass="pdq-mat-select--panel"
                placeholder="trigger"
                [(value)]="currentAllConditionsSelectValue[j][i]"
                (selectionChange)="changeConditionSelect($event, [j, i])"
                [attr.data-2dIndex]="j + ',' + i">
                <!-- meanwhile, the fulfilledExternally condition will be disabled on assign screen (the check is here and not on json to make reverting easier). -->
                <mat-option
                  *ngFor="let condition of conditions[0].values"
                  [value]="condition"
                  [disabled]="
                    condition.disabled ||
                    condition.name === 'fulfilledExternally' ||
                    ruleTemplateService.isOptionAlreadyChosen(
                      condition,
                      i,
                      currentAllConditionsSelectValue[j],
                      currentOperatorValue[j]
                    )
                  ">
                  {{ condition.text }}
                </mat-option>
              </mat-select>
            </div>
            <span
              [ngSwitch]="
                currentAllConditionsSelectValue[j] &&
                currentAllConditionsSelectValue[j][i] &&
                currentAllConditionsSelectValue[j][i].name
              ">
              <div *ngSwitchCase="'totalOrderValue'" class="operator-amount-container" floatLabel="never">
                <span class="padded-txt">is</span>
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [defaultOption]="currentOperatorValue[j][i] || currentAllConditionsSelectValue[j][i].operators[0]"
                  [options]="
                    ruleTemplateService.prepareOperatorOptions(
                      currentAllConditionsSelectValue[j][i].operators,
                      i,
                      RulesAmountType.TOTAL_VALUE,
                      currentAllConditionsSelectValue[j],
                      currentOperatorValue[j]
                    )
                  "
                  buttonFontSize="16"
                  (onChange)="changeOperatorSelect($event, [j, i])">
                </pdq-dropdown>
                <pdq-input-arrows
                  class="operator-amount-container-input"
                  variant="form"
                  mode="currency"
                  min="0"
                  [numberType]="'double'"
                  [border]="true"
                  placeholder="0.00"
                  [value]="currentTotalValueVal[j][i]"
                  debounceTime="500"
                  widthSize="large"
                  [symbol]="shopSettings?.currency"
                  (onKeyup)="onAmountTyped($event, [j, i], RulesAmountType.TOTAL_VALUE)">
                </pdq-input-arrows>
              </div>

              <span *ngSwitchCase="'deliveryMethod'" class="flex">
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [defaultOption]="currentOperatorValue[j][i] || currentAllConditionsSelectValue[j][i].operators[0]"
                  [options]="currentAllConditionsSelectValue[j][i].operators"
                  buttonFontSize="16"
                  (onChange)="changeOperatorSelect($event, [j, i])"
                  [fullWidth]="true">
                </pdq-dropdown>

                <p>{{ getDeliveryMethodOperatorText(currentOperatorValue[j][i]?.value) }}</p>

                <!-- Autocomplete mode for 'is'/'is-not' operators -->
                <ng-container *ngIf="isDeliveryMethodAutoCompleteMode([j, i])">
                  <ng-container *ngIf="currentSelectedDeliveryMethods[j][i]">
                    <pdq-chip
                      *ngFor="let selectedMethod of currentSelectedDeliveryMethods[j][i]; let methodIndex = index"
                      #chipRef
                      [maxWidth]="maximumAutocompleteWidth"
                      [label]="selectedMethod"
                      (onChange)="onDeliveryMethodUnSelect([j, i], methodIndex)">
                    </pdq-chip>
                  </ng-container>
                  <pdq-input
                    #deliveryMethodInput
                    [id]="'deliveryMethodInput' + j + i"
                    [withIcon]="true"
                    placeholder="Add delivery method..."
                    icon="search"
                    [autocompleteMode]="true"
                    [autocompleteRef]="deliveryMethodAutoComplete"
                    [control]="controls[j][i]"
                    background="light"
                    [border]="false"
                    [autoCompleteWidth]="419"
                    [autoCompleteHeight]="112"
                    [offsetPositionX]="-100">
                  </pdq-input>
                  <pdq-autocomplete #deliveryMethodAutoComplete mode="tags">
                    <ng-template pdqAutocompleteContent>
                      <pdq-options
                        *ngFor="let method of deliveryMethods | filterStringResults: controls[j][i].value"
                        (click)="onDeliveryMethodSelect([j, i], method)"
                        [value]="method">
                        <pdq-tag
                          #methodRef
                          [matTooltip]="ruleTemplateService.isTextOverflowed(methodRef) ? '' : method"
                          matTooltipClass="pdq-mat-tooltip"
                          [maxWidth]="maximumAutocompleteWidth"
                          >{{ method }}
                        </pdq-tag>
                      </pdq-options>
                    </ng-template>
                  </pdq-autocomplete>
                </ng-container>

                <!-- Regular input mode for 'contains'/'not-contains' operators -->
                <ng-container *ngIf="!isDeliveryMethodAutoCompleteMode([j, i])">
                  <div class="flex">
                    <pdq-input
                      #deliveryMethodInput
                      [id]="'deliveryMethodRegularInput' + j + i"
                      [withIcon]="false"
                      placeholder="Enter delivery method..."
                      background="light"
                      [border]="false"
                      [(ngModel)]="currentDeliveryMethodInputValue[j][i]"
                      (ngModelChange)="onDeliveryMethodInputChange([j, i], $event)"
                      (blur)="processDeliveryMethodInput([j, i])">
                    </pdq-input>
                  </div>
                </ng-container>
              </span>

              <div *ngSwitchCase="'orderTag'" class="order-tags-condition">
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  placeholder="select condition"
                  [defaultOption]="currentOperatorValue[j][i]"
                  [options]="
                    ruleTemplateService.prepareOperatorOptions(
                      currentAllConditionsSelectValue[j][i].operators,
                      i,
                      RulesAmountType.TAGS,
                      currentAllConditionsSelectValue[j],
                      currentOperatorValue[j]
                    )
                  "
                  buttonFontSize="16"
                  (onChange)="changeOperatorSelect($event, [j, i])">
                </pdq-dropdown>
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [defaultOption]="currentOperator2Value[j][i] || currentAllConditionsSelectValue[j][i].operators2[0]"
                  [options]="
                    ruleTemplateService.prepareOperatorOptions(
                      currentAllConditionsSelectValue[j][i].operators2,
                      i,
                      RulesAmountType.TAGS,
                      currentAllConditionsSelectValue[j],
                      currentOperator2Value[j]
                    )
                  "
                  buttonFontSize="16"
                  (onChange)="changeOperator2Select($event, [j, i])">
                </pdq-dropdown>
                <div *ngIf="currentOperatorValue[j][i]?.value">
                  <div class="auto-complete-wrapper" *ngIf="isAutoCompleteMode([j, i]); else regularInput">
                    <div class="auto-complete__list-options">
                      <ng-container *ngIf="currentSelectedTags[j][i]">
                        <pdq-chip
                          *ngFor="let selectedTag of currentSelectedTags[j][i]; let tagIndex = index"
                          #chipRef
                          [maxWidth]="maximumAutocompleteWidth"
                          [label]="selectedTag.name"
                          (onChange)="onTagRemove([j, i], tagIndex)">
                        </pdq-chip>
                      </ng-container>
                    </div>
                    <pdq-input
                      class="tags-container__tagsInput"
                      #tagsInput
                      [id]="'tagsInput' + j + i"
                      [withIcon]="true"
                      placeholder="Add tags..."
                      icon="search"
                      [autofocus]="true"
                      [autocompleteMode]="true"
                      [autocompleteRef]="pdqAutocomplete"
                      [control]="controls[j][i]"
                      background="light"
                      [border]="false"
                      [autoCompleteWidth]="419"
                      [autoCompleteHeight]="112"
                      [offsetPositionX]="-100">
                    </pdq-input>
                    <pdq-autocomplete #pdqAutocomplete="pdqAutocomplete" mode="tags">
                      <ng-template pdqAutocompleteContent>
                        <ng-container class="is-loading" *ngIf="isLoadingResults">
                          <pdq-spinner></pdq-spinner>
                        </ng-container>
                        <ng-container *ngIf="!isLoadingResults">
                          <pdq-options
                            *ngFor="let tag of tags | filterResults: controls[j][i].value"
                            (click)="onTagSelect([j, i], tag)"
                            [value]="tag.name">
                            <pdq-tag
                              #tagRef
                              [matTooltip]="ruleTemplateService.isTextOverflowed(tagRef) ? '' : tag.name"
                              matTooltipClass="pdq-mat-tooltip"
                              [maxWidth]="maximumAutocompleteWidth"
                              >{{ tag.name }}
                            </pdq-tag>
                          </pdq-options>
                          <div class="no-results-found" *ngIf="!isLoadingResults && !tags.length">
                            <span class="no-results-found__title">No results for "{{ controls[j][i].value }}"</span>
                            <span class="no-results-found__subtitle">Maybe try something else?</span>
                          </div>
                        </ng-container>
                      </ng-template>
                    </pdq-autocomplete>
                  </div>
                  <ng-template #regularInput>
                    <pdq-input
                      placeholder="value"
                      [autofocus]="true"
                      [value]="currentTagsValue[j][i]"
                      background="light"
                      [border]="false"
                      (onKeyup)="onOrderTagConditionChanged($event, [j, i])">
                    </pdq-input>
                  </ng-template>
                </div>
              </div>
              <div *ngSwitchCase="'totalOrderWeight'" class="condition-container" floatLabel="never">
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [placeholder]="AmountOperatorsValues && AmountOperatorsValues[j][i]"
                  [defaultOption]="currentOperatorValue[j][i] || currentAllConditionsSelectValue[j][i].operators[0]"
                  [options]="
                    ruleTemplateService.prepareOperatorOptions(
                      currentAllConditionsSelectValue[j][i].operators,
                      i,
                      RulesAmountType.WEIGHT,
                      currentAllConditionsSelectValue[j],
                      currentOperatorValue[j]
                    )
                  "
                  buttonFontSize="16"
                  (onChange)="changeOperatorSelect($event, [j, i])">
                </pdq-dropdown>
                <pdq-input
                  class="condition-container-input"
                  [placeholder]="currentWeightValue[j][i] || '0.00'"
                  background="light"
                  [border]="false"
                  width="100"
                  type="number"
                  textAlign="center"
                  debounceTime="500"
                  (onKeyup)="onAmountTyped($event, [j, i], RulesAmountType.WEIGHT)">
                </pdq-input>
                <div class="condition-container-units">{{ shopSettings?.weightUnits || 'lb' }}</div>
              </div>
              <div *ngSwitchCase="'itemQuantity'" class="condition-container" floatLabel="never">
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [defaultOption]="currentOperatorValue[j][i] || currentAllConditionsSelectValue[j][i].operators[0]"
                  [options]="
                    ruleTemplateService.prepareOperatorOptions(
                      currentAllConditionsSelectValue[j][i].operators,
                      i,
                      RulesAmountType.ITEM_QUANTITY,
                      currentAllConditionsSelectValue[j],
                      currentOperatorValue[j]
                    )
                  "
                  buttonFontSize="16"
                  (onChange)="changeOperatorSelect($event, [j, i])">
                </pdq-dropdown>
                <pdq-input
                  class="condition-container-input"
                  [placeholder]="
                    (currentItemQuantityValue[j][i] | isNumberPipe) ? currentItemQuantityValue[j][i] : 'quantity'
                  "
                  background="light"
                  [border]="false"
                  width="100"
                  type="number"
                  textAlign="center"
                  debounceTime="500"
                  (onKeyup)="onAmountTyped($event, [j, i], RulesAmountType.ITEM_QUANTITY)">
                </pdq-input>
              </div>
              <div *ngSwitchCase="'inventoryLocation'" class="condition-container" floatLabel="never">
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [defaultOption]="currentOperatorValue[j][i] || currentAllConditionsSelectValue[j][i].operators[0]"
                  [options]="
                    ruleTemplateService.prepareOperatorOptions(
                      currentAllConditionsSelectValue[j][i].operators,
                      i,
                      RulesAmountType.GENERIC,
                      currentAllConditionsSelectValue[j],
                      currentOperatorValue[j]
                    )
                  "
                  buttonFontSize="16"
                  (onChange)="changeOperatorSelect($event, [j, i])">
                </pdq-dropdown>
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [defaultOption]="currentInventoryLocationValue[j][i] || inventoryLocationOptions[0]"
                  [options]="inventoryLocationOptions"
                  buttonFontSize="16"
                  (onChange)="changeInventorySelect($event, [j, i])">
                </pdq-dropdown>
              </div>
              <div *ngSwitchCase="'boxChosen'" class="condition-container" floatLabel="never">
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [defaultOption]="currentOperatorValue[j][i] || currentAllConditionsSelectValue[j][i].operators[0]"
                  [options]="
                    ruleTemplateService.prepareOperatorOptions(
                      currentAllConditionsSelectValue[j][i].operators,
                      i,
                      RulesAmountType.GENERIC,
                      currentAllConditionsSelectValue[j],
                      currentOperatorValue[j]
                    )
                  "
                  buttonFontSize="16"
                  (onChange)="changeOperatorSelect($event, [j, i])">
                </pdq-dropdown>
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [defaultOption]="currentPackageValue[j][i] || (packagesOptions[j][i] && packagesOptions[j][i][0])"
                  placeholder="select package"
                  [options]="packagesOptions[j][i]"
                  [multiSelect]="true"
                  selectBy="checked"
                  buttonFontSize="16"
                  (onMultiSelectOptionChecked)="changePackageSelect($event, [j, i])">
                </pdq-dropdown>
              </div>

              <div *ngSwitchCase="'isFilteredBy'" class="condition-container" floatLabel="never">
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [defaultOption]="currentIsFilterValue[j][i] || (isFiltersOptions[j][i] && isFiltersOptions[j][i][0])"
                  placeholder="select filter"
                  [options]="isFiltersOptions[j][i]"
                  [multiSelect]="true"
                  selectBy="checked"
                  buttonFontSize="16"
                  (onMultiSelectOptionChecked)="
                    changeFilterSelect($event, [j, i], currentAllConditionsSelectValue[j][i].name)
                  ">
                </pdq-dropdown>
              </div>

              <div *ngSwitchCase="'isNotFilteredBy'" class="condition-container" floatLabel="never">
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [defaultOption]="
                    currentIsNotFilterValue[j][i] || (isNotFiltersOptions[j][i] && isNotFiltersOptions[j][i][0])
                  "
                  placeholder="select filter"
                  [options]="isNotFiltersOptions[j][i]"
                  [multiSelect]="true"
                  selectBy="checked"
                  buttonFontSize="16"
                  (onMultiSelectOptionChecked)="
                    changeFilterSelect($event, [j, i], currentAllConditionsSelectValue[j][i].name)
                  ">
                </pdq-dropdown>
              </div>

              <div *ngSwitchCase="'orderSku'" class="order-tags-condition">
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  placeholder="select condition"
                  [defaultOption]="currentOperatorValue[j][i]"
                  [options]="
                    ruleTemplateService.prepareOperatorOptions(
                      currentAllConditionsSelectValue[j][i].operators,
                      i,
                      RulesAmountType.SKUS,
                      currentAllConditionsSelectValue[j],
                      currentOperatorValue[j]
                    )
                  "
                  buttonFontSize="16"
                  (onChange)="changeOperatorSelect($event, [j, i])">
                </pdq-dropdown>
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [defaultOption]="currentOperator2Value[j][i] || currentAllConditionsSelectValue[j][i].operators2[0]"
                  [options]="
                    ruleTemplateService.prepareOperatorOptions(
                      currentAllConditionsSelectValue[j][i].operators2,
                      i,
                      RulesAmountType.SKUS,
                      currentAllConditionsSelectValue[j],
                      currentOperator2Value[j]
                    )
                  "
                  buttonFontSize="16"
                  (onChange)="changeOperator2Select($event, [j, i])">
                </pdq-dropdown>
                <div *ngIf="currentOperatorValue[j][i]?.value">
                  <div class="auto-complete-wrapper" *ngIf="isAutoCompleteMode([j, i]); else regularInput">
                    <div class="auto-complete__list-options">
                      <ng-container *ngIf="currentSelectedSkus[j][i]">
                        <pdq-chip
                          *ngFor="let selectedSku of currentSelectedSkus[j][i]; let skuIndex = index"
                          #chipRef
                          [maxWidth]="maximumAutocompleteWidth"
                          [label]="selectedSku"
                          (onChange)="onSkuRemove([j, i], skuIndex)">
                        </pdq-chip>
                      </ng-container>
                    </div>
                    <pdq-input
                      class="order-item-sku-container__skusInput"
                      #skusInput
                      [id]="'skusInput' + j + i"
                      [withIcon]="true"
                      placeholder="Add SKU..."
                      icon="search"
                      [autofocus]="true"
                      [autocompleteMode]="true"
                      [autocompleteRef]="pdqAutocomplete"
                      [control]="controls[j][i]"
                      background="light"
                      [border]="false"
                      [autoCompleteWidth]="419"
                      [autoCompleteHeight]="112"
                      [offsetPositionX]="-100">
                    </pdq-input>
                    <pdq-autocomplete #pdqAutocomplete="pdqAutocomplete" mode="tags">
                      <ng-template pdqAutocompleteContent>
                        <ng-container class="is-loading" *ngIf="isLoadingResults">
                          <pdq-spinner></pdq-spinner>
                        </ng-container>
                        <ng-container *ngIf="!isLoadingResults">
                          <pdq-options
                            *ngFor="let sku of skus | filterStringResults: controls[j][i].value"
                            (click)="onSkuSelect([j, i], sku)"
                            [value]="sku">
                            <pdq-tag
                              #skuRef
                              [matTooltip]="ruleTemplateService.isTextOverflowed(skuRef) ? '' : sku"
                              matTooltipClass="pdq-mat-tooltip"
                              [maxWidth]="maximumAutocompleteWidth"
                              >{{ sku }}
                            </pdq-tag>
                          </pdq-options>
                          <div class="no-results-found" *ngIf="!isLoadingResults && !skus.length">
                            <span class="no-results-found__title">No results for "{{ controls[j][i].value }}"</span>
                            <span class="no-results-found__subtitle">Maybe try something else?</span>
                          </div>
                        </ng-container>
                      </ng-template>
                    </pdq-autocomplete>
                  </div>
                  <ng-template #regularInput>
                    <pdq-input
                      placeholder="value"
                      [autofocus]="true"
                      [value]="currentSkusValue[j][i]"
                      background="light"
                      [border]="false"
                      (onKeyup)="onOrderSkuConditionChanged($event, [j, i])">
                    </pdq-input>
                  </ng-template>
                </div>
              </div>

              <div *ngSwitchCase="'createdOnSpecificTime'" class="condition-container" floatLabel="never">
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [options]="createdWeekDaysOptions[j][i]"
                  [defaultOption]="currentCreatedOnValue[j][i]?.weekDays"
                  [multiSelect]="true"
                  placeholder="all week days"
                  allSelectedText="all week days"
                  selectBy="checked"
                  buttonFontSize="16"
                  (onMultiSelectOptionChecked)="onOrderCreatedWeekDayConditionChanged($event, [j, i])">
                </pdq-dropdown>
                <span class="padded-txt">from</span>
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [options]="timeOfDayOptions | slice: 0 : -1"
                  [defaultOption]="currentCreatedOnValue[j][i]?.from"
                  buttonFontSize="16"
                  (onChange)="onOrderCreatedTimeOfDayConditionChanged($event, [j, i], 'from')">
                </pdq-dropdown>
                <span class="padded-txt">to</span>
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [options]="timeOfDayOptions | displayRelevantToTime: currentCreatedOnValue[j][i]?.from.value"
                  [defaultOption]="currentCreatedOnValue[j][i]?.to"
                  buttonFontSize="16"
                  (onChange)="onOrderCreatedTimeOfDayConditionChanged($event, [j, i], 'to')">
                </pdq-dropdown>
                <span class="padded-txt">({{ shopSettings?.shopTimeZone }})</span>
              </div>

              <span *ngSwitchCase="'shippingAddressState'" class="flex">
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [defaultOption]="currentOperatorValue[j][i] || currentAllConditionsSelectValue[j][i].operators[0]"
                  [options]="currentAllConditionsSelectValue[j][i].operators"
                  buttonFontSize="16"
                  (onChange)="changeOperatorSelect($event, [j, i])"
                  [width]="85">
                </pdq-dropdown>
                <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                <div class="select-wrapper">
                  <mat-select
                    panelClass="pdq-mat-select--panel__multi"
                    class="pdq-mat-select pdq-mat-select--ghost-underline"
                    placeholder="trigger"
                    placeholder="select state"
                    [value]="currentStateSelectValue && currentStateSelectValue[j][i]"
                    (valueChange)="currentStateSelectValue && (currentStateSelectValue[j][i] = $event)"
                    [disableOptionCentering]="true"
                    (selectionChange)="selectState($event, [j, i])"
                    multiple>
                    <mat-option *ngFor="let state of currentAllConditionsSelectValue[j][i].values" [value]="state">
                      {{ state }}
                    </mat-option>
                  </mat-select>
                </div>
              </span>

              <div *ngSwitchCase="'time'" class="condition-container" floatLabel="never">
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [defaultOption]="currentOperatorValue[j][i] || currentAllConditionsSelectValue[j][i].operators[0]"
                  [options]="currentAllConditionsSelectValue[j][i].operators"
                  buttonFontSize="16"
                  (onChange)="changeOperatorSelect($event, [j, i])"
                  [width]="85">
                </pdq-dropdown>
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [options]="timeWindowWeekDaysOptions[j][i]"
                  [defaultOption]="currentTimeWindowValue[j][i]?.weekDays"
                  [multiSelect]="true"
                  placeholder="all week days"
                  allSelectedText="all week days"
                  selectBy="checked"
                  buttonFontSize="16"
                  (onMultiSelectOptionChecked)="onTimeWindowOfWeekDayConditionChanged($event, [j, i])">
                </pdq-dropdown>
                <span class="padded-txt">between</span>
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [options]="timeWindowOfDayOptions | slice: 0 : -1"
                  [defaultOption]="currentTimeWindowValue[j][i]?.from"
                  buttonFontSize="16"
                  (onChange)="onTimeWindowOfDayConditionChanged($event, [j, i], 'from')">
                </pdq-dropdown>
                <span class="padded-txt">and</span>
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [options]="timeWindowOfDayOptions | displayRelevantToTime: currentTimeWindowValue[j][i]?.from.value"
                  [defaultOption]="currentTimeWindowValue[j][i]?.to"
                  buttonFontSize="16"
                  (onChange)="onTimeWindowOfDayConditionChanged($event, [j, i], 'to')">
                </pdq-dropdown>
                <span class="padded-txt">({{ shopSettings?.shopTimeZone }})</span>
              </div>

              <div *ngSwitchCase="'shipOnDate'" class="condition-container" floatLabel="never">
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [defaultOption]="currentOperatorValue[j][i] || currentAllConditionsSelectValue[j][i].operators[0]"
                  [options]="currentAllConditionsSelectValue[j][i].operators"
                  buttonFontSize="16"
                  (onChange)="changeOperatorSelect($event, [j, i])"
                  [width]="85">
                </pdq-dropdown>
                <pdq-dropdown
                  class="dropdown"
                  mode="tight-ghost"
                  [border]="false"
                  [defaultOption]="currentShipOnDateValue[j][i]?.value || shipOnDateOptions[0]"
                  [options]="shipOnDateOptions"
                  buttonFontSize="16"
                  (onChange)="changeShipOnDateSelect({ property: 'ShipOnDateValue', value: $event }, [j, i])">
                </pdq-dropdown>
                @if (currentShipOnDateValue[j][i]?.value?.label === 'in X days') {
                  <pdq-input-arrows
                    [value]="currentShipOnDateValue[j][i]?.value?.dayNumber || undefined"
                    (onKeyup)="changeShipOnDateSelect({ property: 'x', value: $event }, [j, i])"
                    [min]="0"
                    [max]="60">
                  </pdq-input-arrows>
                  <pdq-dropdown
                    class="dropdown"
                    mode="tight-ghost"
                    [border]="false"
                    buttonFontSize="16"
                    [options]="currentAllConditionsSelectValue[j][i]?.dayTypeValues"
                    [defaultOption]="
                      currentShipOnDateValue[j][i]?.value?.dayType ||
                      currentAllConditionsSelectValue[j][i]?.dayTypeValues[0]
                    "
                    (onChange)="changeShipOnDateSelect({ property: 'dayType', value: $event }, [j, i])">
                  </pdq-dropdown>
                }
              </div>
            </span>

            <span class="action-buttons">
              <pdq-button
                class="delete-button"
                *ngIf="i > 0 || j > 0"
                variant="ghost"
                icon="delete"
                (onClick)="removeCondition([j, i])"></pdq-button>
              <pdq-button
                class="add-button"
                *ngIf="
                  i == currentAllConditionsSelectValue[j].length - 1 && checkIfAllValuesInsertedForConditionGroup(j)
                "
                variant="ghost"
                icon="more"
                (onClick)="addCondition([j, i + 1])">
              </pdq-button>
            </span>
          </div>
        </ng-container>
      </div>

      <div class="add-or-button-div">
        <pdq-button
          class="add-or-button"
          [disabled]="j != currentAllConditionsSelectValue.length - 1"
          *ngIf="j != currentAllConditionsSelectValue.length - 1 || checkIfAllValuesInserted()"
          (onClick)="addOrCondition(j + 1)">
          + OR
        </pdq-button>
      </div>
    </ng-container>
  </div>

  <div class="action">
    <b class="header-text">THEN </b>
    <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
    <div class="select-wrapper" style="margin-top: 8px" *ngIf="!currentActionSelectValue">
      <mat-select
        panelClass="pdq-mat-select--panel"
        class="pdq-mat-select pdq-mat-select--ghost-underline"
        placeholder="action"
        [(value)]="currentActionSelectValue"
        (selectionChange)="changeActionSelect($event)">
        <mat-option
          *ngFor="let action of actions[0].values; index as actionKey"
          [value]="action"
          [disabled]="isActionDisabled(action, actionKey)">
          <span [innerHTML]="getFormattedText(action.text)"></span>
        </mat-option>
      </mat-select>
    </div>
    <span [ngSwitch]="currentActionSelectValue && currentActionSelectValue.name" class="full-width">
      <span class="action-select" *ngSwitchCase="'batchImmediatelyAndAssign'">
        <span [innerHTML]="getActionText(currentActionSelectValue)"></span>
        <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
        <div class="select-wrapper">
          <mat-select
            panelClass="pdq-mat-select--panel"
            class="pdq-mat-select pdq-mat-select--ghost-underline"
            placeholder="delivery service"
            [(value)]="currentDeliveryServiceSelectValue"
            (selectionChange)="selectDeliveryService($event)">
            <mat-option *ngFor="let deliveryService of currentActionSelectValue.values" [value]="deliveryService.id">
              {{ deliveryService.value }}
            </mat-option>
          </mat-select>
        </div>
        <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
        <div class="select-wrapper">
          <mat-select
            panelClass="pdq-mat-select--panel"
            class="pdq-mat-select pdq-mat-select--ghost-underline"
            placeholder="service level"
            [(value)]="currentServiceLevelSelectValue"
            (selectionChange)="selectDeliveryServiceLevel($event)">
            <mat-option *ngFor="let serviceLevel of deliveryServiceLevels" [value]="serviceLevel.serviceLevel_id">
              {{ getServiceLabelDisplayName(serviceLevel.serviceLevel_type) }}
            </mat-option>
          </mat-select>
        </div>
        <span
          class="reset-btn"
          [matTooltip]="'Reset action'"
          matTooltipClass="pdq-mat-tooltip"
          (click)="onResetActionSelectValue()"></span>
      </span>
      <span class="action-select batch-name" *ngSwitchCase="'batchImmediatelyAndAssign'">
        Batch Name
        <pdq-input
          class="name-input"
          variant="form"
          type="text"
          debounceTime="500"
          (onKeyup)="batchNameChanged($event)"
          [value]="batchName">
        </pdq-input>
      </span>
      <span class="action-select" *ngSwitchCase="'batchOnSpecificTimeAndAssign'">
        <div class="batch-on-specific-time-wrapper">
          batch
          <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
          <div class="select-wrapper">
            <mat-select
              panelClass="pdq-mat-select--panel"
              class="pdq-mat-select pdq-mat-select--ghost-underline"
              [(value)]="currentBatchUpToSelectValue"
              (selectionChange)="selectBatchUpToChange($event)">
              <mat-option value="all">all</mat-option>
              <mat-option value="up-to">up to</mat-option>
            </mat-select>
          </div>
          <pdq-input-arrows
            *ngIf="currentBatchUpToSelectValue === 'up-to'"
            class="input-up-to"
            variant="form"
            min="0"
            [border]="true"
            placeholder="0"
            [value]="currentBatchUpToX"
            debounceTime="500"
            (onKeyup)="currentBatchUpToXChange($event)">
          </pdq-input-arrows>
          order(s) and assign it to delivery service
          <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
          <div class="select-wrapper">
            <mat-select
              panelClass="pdq-mat-select--panel"
              class="pdq-mat-select pdq-mat-select--ghost-underline"
              placeholder="delivery service"
              [(value)]="currentDeliveryServiceSelectValue"
              (selectionChange)="selectDeliveryServiceOnSpecificTime($event)">
              <mat-option *ngFor="let deliveryService of currentActionSelectValue.values" [value]="deliveryService.id">
                {{ deliveryService.value }}
              </mat-option>
            </mat-select>
          </div>
          <div class="select-wrapper" *ngIf="deliveryServiceLevels">
            <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
            <mat-select
              panelClass="pdq-mat-select--panel"
              class="pdq-mat-select pdq-mat-select--ghost-underline"
              placeholder="service level"
              [(value)]="currentServiceLevelSelectValue"
              (selectionChange)="selectDeliveryServiceLevel($event)">
              <mat-option *ngFor="let serviceLevel of deliveryServiceLevels" [value]="serviceLevel.serviceLevel_id">
                {{ getServiceLabelDisplayName(serviceLevel.serviceLevel_type) }}
              </mat-option>
            </mat-select>
          </div>
          <span
            class="reset-btn"
            [matTooltip]="'Reset action'"
            matTooltipClass="pdq-mat-tooltip"
            (click)="onResetActionSelectValue()"></span>
        </div>
      </span>
      <div class="action-select on-day-time" *ngSwitchCase="'batchOnSpecificTimeAndAssign'">
        <b>on </b>
        <div class="select-wrapper">
          <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
          <mat-select
            panelClass="pdq-mat-select--panel"
            class="pdq-mat-select pdq-mat-select--ghost-underline"
            placeholder="all week days"
            [(value)]="currentWeekDaysValue"
            (selectionChange)="selectWeekDay($event)"
            multiple>
            <mat-option *ngFor="let weekDay of weekDays" [value]="weekDay">
              {{ weekDay }}
            </mat-option>
          </mat-select>
        </div>
        <b class="at">at </b>
        <span
          ><!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
          <input
            class="time-input"
            [ngxTimepicker]="timePicker"
            [value]="currentTimePickerValue"
            [format]="12"
            readonly />
          <ngx-material-timepicker #timePicker (timeSet)="setCurrentTimePickerValue($event)"></ngx-material-timepicker>
          <span class="shop-time-zone">({{ shopSettings?.shopTimeZone }})</span>
        </span>
      </div>
      <span class="action-select batch-name-specific-time" *ngSwitchCase="'batchOnSpecificTimeAndAssign'">
        Batch Name
        <pdq-input
          class="name-input"
          variant="form"
          type="text"
          debounceTime="500"
          (onKeyup)="batchNameChanged($event)"
          [value]="batchName">
        </pdq-input>
      </span>
      <span class="action-select" *ngSwitchCase="'setRecommendedCarrier'">
        <div class="recommended-carrier" [ngClass]="shipOnSelectValue?.shipOn ? 'ship-on-content' : 'ship-on-select'">
          <div class="recommended-carrier-text">set the following shipment preferences to the order</div>
          <app-relative-days
            text="Ship on"
            placeholder="Ship on"
            [deliveryDateOptions]="deliveryDateOptions"
            [options]="currentActionSelectValue.shipOnValues"
            [dayTypeOptions]="currentActionSelectValue.dayTypeValues"
            (dataChanged)="shipOnChanged($event)"
            [selectValue]="currentShipOnValue"
            [displayDeleteInput]="true"></app-relative-days>
          <div class="shipment-preferences-wrapper">
            <app-shipment-preferences
              [carriersData]="carriersData"
              [isEditable]="true"
              [isQuickflow]="true"
              [withoutButtons]="true"
              (onFormChanged)="onShipmentPreferencesChanged($event)"
              [initialForm]="currentRecommendedCarrier"></app-shipment-preferences>
          </div>
        </div>
        <span
          class="reset-btn"
          matTooltip="Reset action"
          matTooltipClass="pdq-mat-tooltip"
          (click)="onResetActionSelectValue()"></span>
      </span>
      <span class="action-select" *ngSwitchCase="'setReturnPreferences'">
        <div style="display: flex; flex-direction: column">
          <div class="recommended-carrier-text" style="padding: 14px 4px; display: flex; align-items: center">
            set the following return preferences to the order
            <span
              class="reset-btn"
              matTooltip="Reset action"
              matTooltipClass="pdq-mat-tooltip"
              (click)="onResetActionSelectValue()"></span>
          </div>
          <return-preferences-form
            *ngIf="shopService.shopDefaultBoxes$ | async as shopBoxes"
            [isQuickflow]="true"
            [hideFeatureToggle]="true"
            [allowCustomBox]="false"
            [allowCustomReturnAddress]="false"
            [shopBoxes]="shopBoxes.activeBoxes"
            [shopLocations]="shopService.shop.shopLocations"
            [shopReturnAddress]="shopService.shop.postOfficeReturn"
            [shopCarriers]="shopCarriers"
            [initialPreferences]="initialReturnPreferences"
            (onFormInit)="onReturnPreferencesFormInit($event)"></return-preferences-form>
        </div>
      </span>
      <span class="action-select" *ngSwitchCase="'changeOrderStatus'">
        <span [innerHTML]="getActionText(currentActionSelectValue)"></span>
        <span
          class="reset-btn"
          [matTooltip]="'Reset action'"
          matTooltipClass="pdq-mat-tooltip"
          (click)="onResetActionSelectValue()"></span>
      </span>
      <span class="action-select" *ngSwitchCase="'moveOrderToPause'">
        <span [innerHTML]="getActionText(currentActionSelectValue)"></span>
        <span
          class="reset-btn"
          [matTooltip]="'Reset action'"
          matTooltipClass="pdq-mat-tooltip"
          (click)="onResetActionSelectValue()"></span>
      </span>
      <span class="action-select" *ngSwitchCase="'unpauseOrder'">
        <span [innerHTML]="getActionText(currentActionSelectValue)"></span>
        <span
          class="reset-btn"
          [matTooltip]="'Reset action'"
          matTooltipClass="pdq-mat-tooltip"
          (click)="onResetActionSelectValue()"></span>
      </span>
      <span class="action-select full-width" *ngSwitchCase="'addTeamNote'">
        <div class="team-note-action-row full-width">
          <span [innerHTML]="getActionText(currentActionSelectValue)" class="aligned"></span>
          <div class="text-area-wrapper">
            <app-mentions-textarea
              class="team-note-textarea"
              placeholder=""
              [noteMessage]="currentTeamNote?.message || ''"
              [selectedMentions]="currentTeamNote?.userCollaboration"
              (teamNoteChanged)="onTeamNoteChanged($event)">
            </app-mentions-textarea>
          </div>
          <pdq-icon
            (click)="onResetActionSelectValue()"
            icon="close"
            class="close aligned"
            size="medium"
            color="flint"
            [matTooltip]="'Reset action'"
            matTooltipClass="pdq-mat-tooltip">
          </pdq-icon>
        </div>
      </span>
      <span class="action-select full-width" *ngSwitchCase="'addTags'">
        <span [innerHTML]="getActionText(currentActionSelectValue)" class="aligned"></span>
        <app-add-tags
          [isDialog]="false"
          (tagsChanged)="tagsChanged($event, 'add')"
          [initialTags]="currentActionAddTagsValue"></app-add-tags>
        <pdq-icon
          (click)="onResetActionSelectValue()"
          icon="close"
          class="close aligned"
          size="medium"
          color="flint"
          [matTooltip]="'Reset action'"
          matTooltipClass="pdq-mat-tooltip">
        </pdq-icon>
      </span>
      <span class="action-select full-width" *ngSwitchCase="'deleteTags'">
        <span [innerHTML]="getActionText(currentActionSelectValue)" class="aligned"></span>
        <app-add-tags
          [isDialog]="false"
          (tagsChanged)="tagsChanged($event, 'delete')"
          [initialTags]="currentActionDeleteTagsValue"></app-add-tags>
        <pdq-icon
          (click)="onResetActionSelectValue()"
          icon="close"
          class="close aligned"
          size="medium"
          color="flint"
          [matTooltip]="'Reset action'"
          matTooltipClass="pdq-mat-tooltip">
        </pdq-icon>
      </span>
      <span class="action-select flex-horizen" *ngSwitchCase="'setShipmentExtras'">
        <div class="shipment-action-row">
          <span [innerHTML]="getActionText(currentActionSelectValue)"></span>
          <pdq-icon
            (click)="onResetActionSelectValue()"
            icon="close"
            class="close centered"
            size="medium"
            color="flint"
            [matTooltip]="'Reset action'"
            matTooltipClass="pdq-mat-tooltip">
          </pdq-icon>
        </div>
        <div class="shipment-extras-fields-container">
          <app-shipment-extras-fields
            [isEditable]="true"
            size="small"
            [shipmentExtras]="currentShipmentExtras?.shipmentExtrasFields"
            (onFormChanged)="onShipmetExtrasChanged($event)">
          </app-shipment-extras-fields>
        </div>
      </span>
      <span class="action-select" *ngSwitchCase="'snoozeOrder'">
        <span *ngIf="!currentSnoozeSelectValue?.snoozeBy" [innerHTML]="getActionText(currentActionSelectValue)"></span>
        <app-relative-days
          text="Snooze order(s)"
          placeholder="date & time to unsnooze"
          [deliveryDateOptions]="deliveryDateOptions"
          [options]="currentActionSelectValue.values"
          (dataChanged)="snoozeChanged($event)"
          [selectValue]="currentSnoozeSelectValue"
          [displayConjunctions]="true"></app-relative-days>
        <span
          class="reset-btn"
          [matTooltip]="'Reset action'"
          matTooltipClass="pdq-mat-tooltip"
          (click)="onResetActionSelectValue()"></span>
      </span>
      <span class="action-select" *ngSwitchCase="'changeDeliveryMethod'">
        <span [innerHTML]="getActionText(currentActionSelectValue)"></span>
        <span class="to-text">to</span>
        <pdq-input
          class="name-input"
          variant="form"
          width="193"
          type="text"
          debounceTime="500"
          value="{{ deliveryMethod }}"
          (onKeyup)="onDeliveryMethodChanged($event)">
        </pdq-input>
        <span
          class="reset-btn"
          [matTooltip]="'Reset action'"
          matTooltipClass="pdq-mat-tooltip"
          (click)="onResetActionSelectValue()"></span>
      </span>
      <span class="action-select" *ngSwitchCase="'setColorCoding'">
        <span>automatically</span>
        <pdq-dropdown
          class="setRecommendedCarrier-dropdown"
          mode="tight-ghost"
          buttonFontSize="16"
          [border]="false"
          placeholder="operator"
          [options]="colorCodingOptions"
          [defaultOption]="currentColorCodingOperator"
          (onChange)="onColorCodingChanged(null, $event)">
        </pdq-dropdown>
        <div class="color-coding-picker">
          <pdq-color-tag-picker
            variant="drop-down"
            [colorOptions]="currentColorCoding"
            (onApply)="onColorCodingChanged($event)"
            (onBackdropClick)="currentColorCoding = handleColorCodingBackdropClick(currentColorCoding)"
            [shopColors]="colorCodingData"></pdq-color-tag-picker>
        </div>
        <span>color coding</span>
        <span
          class="reset-btn"
          [matTooltip]="'Reset action'"
          matTooltipClass="pdq-mat-tooltip"
          (click)="onResetActionSelectValue()"></span>
      </span>
      <span class="action-select" *ngSwitchCase="'splitOrderBy'">
        <app-split-order-rule
          (onChangeActionSelect)="onChangeActionSelect.emit($event)"
          [currentActionSelectValue]="currentActionSelectValue"
          [conditions]="actions[0].values"
          [selectedActionValue]="splitOrderData">
        </app-split-order-rule>
        <span
          class="reset-btn"
          [matTooltip]="'Reset action'"
          matTooltipClass="pdq-mat-tooltip"
          (click)="onResetActionSelectValue()">
        </span>
      </span>
      <span class="action-select" *ngSwitchCase="'pinOrder'">
        <span [innerHTML]="getActionText(currentActionSelectValue)"></span>
        <span
          class="reset-btn"
          [matTooltip]="'Reset action'"
          matTooltipClass="pdq-mat-tooltip"
          (click)="onResetActionSelectValue()"></span>
      </span>
      <span class="action-select" *ngSwitchCase="'smartShipOn'">
        <div class="recommended-carrier">
          <div class="recommended-carrier-text">
            <span [innerHTML]="getActionText(currentActionSelectValue)"></span>
          </div>
          <div class="smart-ship-on-wrapper">
            <app-shipment-preferences
              [carriersData]="carriersData"
              [isEditable]="true"
              [isQuickflow]="true"
              [withoutButtons]="true"
              (onFormChanged)="onSmartShipOnChanged($event, 'shipmentPreferncesFields')"
              [initialForm]="currentSmartShipOn?.shipmentPreferncesFields"></app-shipment-preferences>
            <div class="smart-ship-on-optimise-for-wrapper">
              <div style="display: flex; align-items: flex-end; gap: 8px">
                <pdq-radio-group
                  label="Optimise for"
                  labelSize="small"
                  (onChange)="
                    onSmartShipOnChanged($event, $event === 'rightOnTime' ? 'rightOnTime' : 'bufferDelayRisk')
                  ">
                  <pdq-radio-button
                    [value]="'rightOnTime'"
                    [checked]="currentSmartShipOn?.rightOnTime"
                    [text]="'Right on time - best shipping method to arrive right on time'">
                  </pdq-radio-button>
                  <pdq-radio-button
                    [value]="'bufferDelayRisk'"
                    [checked]="currentSmartShipOn?.bufferDelayRisk?.value === true"
                    [text]="'Zero delays - best shipping method to minimize delay possibility, set days buffer to'">
                  </pdq-radio-button>
                </pdq-radio-group>
                <pdq-input-arrows
                  [value]="currentSmartShipOn?.bufferDelayRisk?.delayDays || undefined"
                  (onKeyup)="onSmartShipOnChanged($event, 'delayDays')"
                  [min]="0"
                  [max]="60">
                </pdq-input-arrows>
                <span
                  class="reset-btn"
                  matTooltip="Reset action"
                  matTooltipClass="pdq-mat-tooltip"
                  (click)="onResetActionSelectValue()"></span>
              </div>
            </div>
          </div>
        </div>
      </span>
    </span>
  </div>

  <div class="approve-notification" *ngIf="headsUp?.length">
    <span>
      <b>Heads up:</b>
      <span *ngFor="let message of headsUp" class="list-item notification-item">
        <span [innerHtml]="message"></span>
      </span>
    </span>
  </div>
</div>
